import React from "react";
import { Bot } from "lucide-react";

export const TypingIndicator: React.FC = () => (
  <div className="flex items-center gap-3 px-4 py-2">
    <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
      <Bot className="w-4 h-4 text-orange-600" />
    </div>
    <div className="flex items-center gap-2">
      <div className="flex gap-1">
        <div
          className="w-2 h-2 bg-orange-400 rounded-full animate-bounce"
          style={{ animationDelay: "0ms" }}
        ></div>
        <div
          className="w-2 h-2 bg-orange-400 rounded-full animate-bounce"
          style={{ animationDelay: "150ms" }}
        ></div>
        <div
          className="w-2 h-2 bg-orange-400 rounded-full animate-bounce"
          style={{ animationDelay: "300ms" }}
        ></div>
      </div>
      <span className="text-sm text-orange-500">Assistant is thinking....</span>
    </div>
  </div>
);
